import { render, staticRenderFns } from "./ExtrusionPanel.vue?vue&type=template&id=a045efd0&scoped=true&"
import script from "./ExtrusionPanel.vue?vue&type=script&lang=js&"
export * from "./ExtrusionPanel.vue?vue&type=script&lang=js&"
import style0 from "./ExtrusionPanel.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ExtrusionPanel.vue?vue&type=style&index=1&id=a045efd0&lang=scss&scoped=true&"
import style2 from "./ExtrusionPanel.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a045efd0",
  null
  
)

export default component.exports